"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactLeaflet = require("react-leaflet");

var _leafletGestureHandling = require("leaflet-gesture-handling");

require("./style.less");

require("leaflet/dist/leaflet.css");

require("leaflet-gesture-handling/dist/leaflet-gesture-handling.css");

var _leaflet2 = _interopRequireDefault(require("leaflet"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Leaflet shoddywork incoming
delete _leaflet2.default.Icon.Default.prototype._getIconUrl;

_leaflet2.default.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

_leaflet2.default.Map.addInitHook('addHandler', 'gestureHandling', _leafletGestureHandling.GestureHandling);

var MapWithPins = function MapWithPins(_ref) {
  var intl = _ref.intl,
      latitude = _ref.latitude,
      longitude = _ref.longitude,
      zoom = _ref.zoom,
      _ref$pins = _ref.pins,
      pins = _ref$pins === void 0 ? [] : _ref$pins;
  var t = intl.messages;
  var position = [latitude, longitude];
  return /*#__PURE__*/_react.default.createElement(_reactLeaflet.Map, {
    center: position,
    zoom: zoom,
    className: "MapWithPins",
    gestureHandling: true,
    gestureHandlingOptions: {
      duration: 2000,
      text: {
        touch: t.map_scroll_touch,
        scroll: t.map_scroll_scroll,
        scrollMac: t.map_scroll_scrollMac
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_reactLeaflet.TileLayer, {
    attribution: "&copy <a href=\"http://osm.org/copyright\">OpenStreetMap</a> contributors",
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  }), pins.map(function (_ref2, index) {
    var pin_lat = _ref2.latitude,
        pin_lon = _ref2.longitude,
        text = _ref2.text;
    return /*#__PURE__*/_react.default.createElement(_reactLeaflet.Marker, {
      key: index,
      position: [pin_lat, pin_lon]
    }, /*#__PURE__*/_react.default.createElement(_reactLeaflet.Popup, null, text));
  }));
};

var _default = MapWithPins;
exports.default = _default;